/* eslint-disable no-use-before-define */
import React from 'react'

export default ({dateRange, setDateRange, dataName='municipals-market-news-date-picker-select', size=6}) =>
    <React.Fragment>
    <div className={`col-lg-${12-size} col-md-2`}></div>
    <div className={`form-group col-lg-${size} col-md-10`} style={{ marginBottom:0 }}>
    <label>Date Range</label>
    <div className="select-wrapper">
        <select
            className="form-control"
            data-name={dataName + '-select'}
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
        >
        {
            dateRanges.map((a, i) =>
                <option
                    data-name={dataName + '-option'}
                    key={i}
                    value={a.value}>{a.label}</option>
            )
        }
        </select>
    </div>
    </div>
    </React.Fragment>

const dateRanges = [
    {value:'today', label: 'Today'},
    {value:'this_week', label: 'This week'},
    {value:'this_month', label: 'This month'}
]
